import React, { useEffect, useState } from "react";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControlLabel, TextField, Typography } from "@mui/material";

const BinTimeModal = ({ entries, busy, onClose, onSubmit }) => {
  const [hours, setHours] = useState("");
  const [binAll, setBinAll] = useState(false);
  useEffect(() => {
    setHours("");
    setBinAll(entries.length > 1);
  }, [entries]);
  const available = entries.length ? Math.min(...entries.map((entry) => Number(entry.workHour))) : 0;
  const value = Number(hours);
  const valid = binAll || (/^\d+(?:\.\d{1,2})?$/.test(hours) && value > 0 && value <= available);
  const remaining = Math.max(0, available - (binAll ? available : Number(hours) || 0));
  return (
    <Dialog open={entries.length > 0} onClose={() => { if (!busy) onClose(); }} fullWidth maxWidth="sm">
      <DialogTitle>Move time to Bin</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          {entries.length === 1
            ? `Available time: ${available.toFixed(2)} hours`
            : `${entries.length} selected entries. Enter hours to bin from each entry, or select all remaining time.`}
        </Typography>
        <FormControlLabel control={<Checkbox checked={binAll} disabled={busy}
          onChange={(event) => setBinAll(event.target.checked)} />}
          label="Bin full entry (select all remaining time)" />
        <TextField autoFocus fullWidth label={entries.length > 1 ? "Hours to bin per entry" : "Hours to bin"}
          value={hours} disabled={binAll || busy} sx={{ mt: 1, mb: 2 }}
          onChange={(event) => { if (/^\d*\.?\d{0,2}$/.test(event.target.value)) setHours(event.target.value); }}
          inputProps={{ inputMode: "decimal" }}
          helperText={entries.length > 1 ? `Maximum per entry: ${available.toFixed(2)} hours` : "Example: bin 3 of 5 hours to show and bill 2 hours."} />
        {entries.length === 1 && <Typography>Remaining in TS and invoices: {remaining.toFixed(2)} hours</Typography>}
        <Typography variant="body2" sx={{ mt: 1 }}>The resource’s recorded time stays unchanged.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button variant="contained" disabled={busy || !valid}
          onClick={() => onSubmit({ binAll, hoursToBin: binAll ? undefined : value })}>
          {busy ? "Moving…" : "Move to Bin"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default BinTimeModal;
